import { Link, Text, VStack } from '@direct-frontend/components';
import { useGetOrderRecommendationsQuery } from '@/entities/order';
import { type SchemaRecommendedProductCard } from '@/shared/api/openApi';
import { type OrderDto } from '@/shared/api/order';
import { ResponsiveImage } from '@/shared/components/ResponsiveImage';
import { formatPrice } from '@/shared/lib/formatPrice';
import { getProductImage } from '@/shared/lib/getProductImage';
import styles from './Recommendations.module.css';

const RecommendationCard = ({ item }: { item: SchemaRecommendedProductCard }) => {
    const { name, link_url, media, price, final_price: finalPrice } = item;

    return (
        <VStack gap="8">
            <Link href={link_url} target="_blank">
                <ResponsiveImage
                    width="100%"
                    height="236"
                    src={getProductImage(media[0])}
                    borderRadius="8"
                    alt={name}
                />
            </Link>
            <VStack gap="4">
                <div className={styles.prices}>
                    <Text size="mc">{formatPrice(finalPrice)}</Text>

                    {price && price !== finalPrice && (
                        <Text size="s" role="supplementary" className={styles.priceOld}>
                            {formatPrice(price)}
                        </Text>
                    )}
                </div>
                <Text size="s">{name}</Text>
            </VStack>
        </VStack>
    );
};

interface RecommendationsProps {
    orderId: OrderDto['id'];
    signature: string;
    storeSlug: string;
}

export const Recommendations = (props: RecommendationsProps) => {
    const { orderId, signature, storeSlug } = props;
    const { data: recommendations, isFetching } = useGetOrderRecommendationsQuery({
        order_id: orderId,
        signature,
        store_slug: storeSlug,
    });

    if (isFetching) {
        return null;
    }

    if (!recommendations || !recommendations.items || recommendations?.items?.length === 0) {
        return null;
    }

    return (
        <VStack gap="16">
            <Text size="l" bold>
                Ещё может понравиться
            </Text>
            <div className={styles.container}>
                {recommendations?.items.map((item, index) => (
                    <RecommendationCard key={index} item={item} />
                ))}
            </div>
        </VStack>
    );
};
